import type { MetricPerfomanceHeaderProp } from '../model/types'

import { useMemo } from 'react'
import { DownloadIcon } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import { useModals } from '@/shared/lib/modal-manager'

import { MainDashboardFilter } from './Filter'
import { MultiPeriodsSelect } from './Periods'

export default function MetricPerfomanceHeader({
	data,
	params,
	onFilterChange,
	periods,
	defaultPeriods,
	setPeriods,
	commonFilters,
}: MetricPerfomanceHeaderProp) {
	const { showModal } = useModals()
	const filters = useMemo(
		() => [...commonFilters, ...(params.filters ?? [])],
		[params.filters, commonFilters]
	)
	/**
	 * Handler for open modal to download metric perfomance report
	 */
	const handleExportReportClick = () =>
		showModal('EXPORT_ADDITIONAL_DATA', {
			kind: data.kind,
			fields: data.fields,
			rows: data.rows,
			defaultName: data.name,
		})

	return (
		<div className='flex w-full justify-between'>
			<MainDashboardFilter
				irremovableCount={commonFilters.length}
				filters={filters ?? []}
				onChange={onFilterChange}
			/>
			<div className='flex items-center'>
				<MultiPeriodsSelect
					periods={periods}
					defaultPeriods={defaultPeriods}
					onChangePeriods={setPeriods}
				/>
				<Button className='ml-2' onClick={handleExportReportClick} size='icon'>
					<DownloadIcon />
				</Button>
			</div>
		</div>
	)
}
